import * as React from 'react';
import Svg from 'react-native-svg';
import Turtle from './images/Turtle';
import Glasses from './images/facials/Glasses';
import Eyes from './images/hats/Eyes';
import Eyebrows from './images/facials/Eyebrows';
import Mask from './images/facials/Mask';
import Meme from './images/facials/Meme';
import Piercings from './images/facials/Piercings';
import Pirate from './images/facials/Pirate';
import Pride from './images/facials/Pride';
import Tears from './images/facials/Tears';
import Teeth from './images/facials/Teeth';
import FriedEgg from './images/hats/FriedEgg';
import Halo from './images/hats/Halo';
import HeadbandBlue from './images/hats/HeadbandBlue';
import HeadbandPurple from './images/hats/HeadbandPurple';
import HeadbandRed from './images/hats/HeadbandRed';
import HeadbandYellow from './images/hats/HeadbandYellow';
import Hearts from './images/hats/Hearts';
import Horns from './images/hats/Horns';
import TurtlePreview from './images/TurtlePreview';

export const profileAvatarFacials = [
  { key: 'eyebrows', Component: Eyebrows },
  { key: 'glasses', Component: Glasses },
  { key: 'mask', Component: Mask },
  { key: 'meme', Component: Meme },
  { key: 'piercings', Component: Piercings },
  { key: 'pirate', Component: Pirate },
  { key: 'pride', Component: Pride },
  { key: 'tears', Component: Tears },
  { key: 'teeth', Component: Teeth },
];

export const profileAvatarHats = [
  { key: 'eyes', Component: Eyes },
  { key: 'friedegg', Component: FriedEgg },
  { key: 'halo', Component: Halo },
  { key: 'headbandblue', Component: HeadbandBlue },
  { key: 'headbandpurple', Component: HeadbandPurple },
  { key: 'headbandred', Component: HeadbandRed },
  { key: 'headbandyellow', Component: HeadbandYellow },
  { key: 'hearts', Component: Hearts },
  { key: 'horns', Component: Horns },
];

export default function ProfileAvatar({ avatar = 'default', style }) {
  // For backwards compatibility don't look for the position
  const images = avatar.split('-');
  const useImage = (name) => images.includes(name);

  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.04 176.02" style={style}>
      {[
        { key: 'default', Component: Turtle },
        { key: 'preview', Component: TurtlePreview },
        ...profileAvatarFacials,
        ...profileAvatarHats,
      ].map(({ key, Component }) => useImage(key) && <Component key={key} />)}
    </Svg>
  );
}
